import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDataModel } from '@modules/auth';
import { ResponseModel } from '@modules/auth/_models/response.model';
import { Reply } from '@modules/post/_models/post-reply-view.model';
import { PostViewModel } from '@modules/post/_models/post-view.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root'
})
export class HttpLikesService {

  constructor(private http: HttpClient) { }

  likePost(id: number): Observable<ResponseModel<PostViewModel>> {
    const postParams = { 
      params: {id: `${id}`}
    }
    return this.http.post<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/like-post`, {}, postParams);
  }

  unlikePost(id: number): Observable<ResponseModel<PostViewModel>> {
    const postParams = { 
      params: {id: `${id}`}
    }
    return this.http.post<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/unlike-post`, {}, postParams);
  }

  likeReply(id: number): Observable<ResponseModel<Reply>> {
    const postParams = { 
      params: {id: `${id}`}
    }
    return this.http.post<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/like-reply`, {}, postParams);
  }

  unlikeReply(id: number): Observable<ResponseModel<Reply>> {
    const postParams = { 
      params: {id: `${id}`}
    }
    return this.http.post<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/unlike-reply`, {}, postParams);
  }

  getPostLikesById(id: number): Observable<ResponseModel<UserDataModel[]>> {
    return this.http.get<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/get-post-likes-by-id/${id}`,);
  }

  getReplyLikesById(id: number): Observable<ResponseModel<UserDataModel[]>> {
    return this.http.get<ResponseModel<any>>(`${API_USERS_URL}/v1/Post/get-reply-likes-by-id/${id}`,);
  }
}